import { media } from './helpers'
import { Howl } from 'howler'

export const bombs = [
    new Howl({
        src: [media('audio/fx/atomic-bomb-1.mp3')],
        volume: .4,
        html5: window.isMobile.any,
    }),

    new Howl({
        src: [media('audio/fx/atomic-bomb-2.mp3')],
        volume: .4,
        html5: window.isMobile.any,
    }),

    new Howl({
        src: [media('audio/fx/muffled-distant.mp3')],
        volume: .4,
        html5: window.isMobile.any,
    }),
];

// replace as needed
export const waves = [
    new Howl({
        src: [media('audio/fx/Wave3.mp3')],
        volume: .5,
        html5: window.isMobile.any,
    }),

    new Howl({
        src: [media('audio/fx/Wave3.mp3')],
        volume: .5,
        html5: window.isMobile.any,
    }),

    new Howl({
        src: [media('audio/fx/Wave3.mp3')],
        volume: .5,
        html5: window.isMobile.any,
    }),
]